export default {
  verificationReview: {
    open: 'Review verification',
    title: 'Verify this run',
    description:
      'You are accepting the unresolved checks listed below. This does not change the solver result or automated verdict.',
    automated: 'Automated verdict: {{verdict}}',
    convergenceNotMeasured: 'Convergence was not measured for this run.',
    noEvidence: 'No further evidence was recorded for this check.',
    confirm: 'Confirm verification',
    cancel: 'Cancel',
    remove: 'Remove verification',
    by: 'Reviewed by {{name}} · {{time}}',
    stale:
      'A newer attempt is current. Refresh the design point before reviewing it.',
    ineligibleVerdict:
      'Review verification is unavailable while the automated verdict is {{verdict}}.',
    ineligibleNoUnresolved:
      'There are no unresolved solver checks to acknowledge.',
    ineligibleMissingVerification:
      'No automated verification record is available for this attempt, so reviewer verification cannot run.',
    setupWrongLead:
      'Automated checks found a setup problem. Fix what failed, then re-run.',
    setupWrongDetails: 'See details',
    acceptDesignIntent: 'Accept as design intent',
    askAdvisorAboutSetup: 'Ask advisor',
    designIntentPrompt:
      'Study {{studyId}}, design point {{dpId}} (simulation {{attemptId}}). Automated verification reported Incorrect setup: {{summary}}. Treat this as design intent for this run — acknowledge the failing setup checks so the point can be Verified without changing the solver result, and say whether friction or near-wall numbers should still be treated as inadmissible.',
    designIntentSessionTitle: 'Design intent · setup check',
    setupWrongNoReview:
      'Setup checks failed; approve Hand Calc relations to mark this run Verified, or fix setup and re-run.',
    retryMeshYplus:
      'This is a near-wall mesh issue (y⁺), not a wrong boundary condition. Refine the wall mesh (or its y⁺ target) and re-run.',
    yPlusDiagram: {
      aria: 'Wall y⁺ bands: ideal low-Re below 5, buffer 5–30 where this run landed, ideal wall functions above 30',
      axis: 'y⁺ (first cell)',
      lowRe: 'y⁺ < 5',
      buffer: 'y⁺ 5–30',
      wallFunction: 'y⁺ > 30',
      ideal: 'Ideal',
      thisRun: 'This run',
      thisRunFrac: 'This run · {{frac}}%',
      caption:
        'Green and blue are valid near-wall treatments. Red is the buffer layer — neither treatment applies; keep wall area there under the limit.',
    },
    retryFlowType:
      'The flow problem type does not match this mesh. Confirm internal vs external flow setup, then re-mesh or re-run.',
    retryBoundaryConditions:
      'Check the inlet or far-field boundary conditions (speed, pressure, freestream) against the case, then re-run.',
    retryContinueAfterSetup:
      'After fixing setup, continue or re-run — this attempt stopped before a trustworthy finish.',
    retrySetupGeneric:
      'Correct the failing setup items below, then re-run the design point.',
    checkNames: {
      wall_spacing: 'Wall y⁺ distribution',
      wall_spacing_target: 'Wall y⁺ target',
      mass_balance: 'Mass balance',
      energy_balance: 'Energy conservation',
      boundary_flux_resolution: 'Boundary flux resolution',
      temperature_bounds: 'Temperature bounds',
      flow_type: 'Flow problem type',
      stagnation: 'Stagnation pressure check',
      reference_area: 'Reference area',
      length_scale: 'Length scale',
      convergence: 'Convergence',
      thermal_resistance: 'Thermal resistance',
      port_vs_wall_closure: 'Coolant heat, ports vs walls',
      part_heat_balance: 'Per-part heat balance',
      contacts_expected: 'Expected contacts',
      contact_area: 'Contact area',
      heat_placement: "Heat on each part's own cells",
      contact_pressure: 'Contact pressure',
      displacement_scale: 'Displacement scale',
      stress_resolution: 'Stress resolution',
    },
  },
  handCalc: {
    workspaceViews: 'Hand Calc views',
    resultsTab: 'Results',
    relationsTab: 'Relations',
    assumptionsTab: 'Assumptions',
    aiNote: 'AI note',
    savedChecks: 'Saved relation checks',
    checksSummary: 'Relation checks · {{approved}}/{{total}} approved',
    checksAgentWrittenAside_one:
      '· {{count}} agent-written (review in Relations)',
    checksAgentWrittenAside_other:
      '· {{count}} agent-written (review in Relations)',
    relationApprovalDoesNotVerify:
      'Approving a relation check does not change the run status. Use Review verification only when unresolved solver checks need an editor acknowledgement.',
    relationApprovalPromotesVerified:
      'Approve every catalogue relation check to mark this run Verified when setup or unresolved solver checks need acknowledgement. Agent-written free equations are not approval targets.',
    addedByYou: 'Added by you',
    addedByAI: 'Added by AI',
    addedByUser: 'Added by a user',
    addedByOther: 'Added by {{name}}',
    reviewed: 'Reviewed by a user',
    reviewedByYou: 'Reviewed by you',
    reviewedByOther: 'Reviewed by {{name}}',
    approvedByYou: 'Approved by you',
    approvedByOther: 'Approved by {{name}}',
    notReviewed: 'Not approved',
    approve: 'Approve',
    approveProposed: 'Approve',
    proposedNeedsRelations:
      'Agent-written free equation (no catalogue template). Open Relations to inspect it — Approve applies only to catalogue templates, and this row does not block Verified.',
    clearApproval: 'Remove approval',
    markReviewed: 'Mark reviewed',
    clearReview: 'Clear review',
    agentGenerated: 'Agent generated',
    structuralRelation: 'From run and case data',
    structuralRelationHelp:
      'This read-only relation is built from recorded simulation results and submitted case values. It was not cited or added by the AI.',
    referenceSource: {
      runResult: 'Run result',
      mesh: 'Mesh',
      caseInput: 'Case input',
      wallNoFlow: 'wall; no mass crosses it',
      derivedBalance: 'Derived by balance',
      balanceAt: 'Balance at',
      interface: 'interface',
      region: 'region',
      typedFor: 'Typed for {{relation}} ({{symbol}})',
      fluidLibrary: 'Fluid library · {{material}} · {{property}}',
      reportedOncePerCase: 'reported once for the case',
    },
    aiMissingCoolantInputs:
      'Thermal resistance checks the whole model only. Flow and convection checks need coolant properties and a path length.',
    aiExplanationGeneric:
      'Some checks need more inputs or a valid scope. Review the relations.',
    sourceCopy: {
      netBalance: 'Entering + generated here − leaving.',
      sourceHeatPathAssumption:
        'Assumes all source heat leaves by this path. This run has not confirmed that.',
      hottestSolidAssumption:
        'Uses the hottest solid temperature reported by the run.',
      thermalResistanceReference: 'Whole-model thermal-resistance definition',
      steadyStateAssumption:
        'Steady state: no energy accumulates in this region.',
      surfaceHeatFluxSameFaceAssumption:
        'Q and A describe the same face and the same final solver step.',
      surfaceHeatFluxAverageAssumption:
        'A is the measured face area; this is an average, not a local peak flux.',
      surfaceHeatFluxReference: 'Surface heat flux, area-averaged definition',
      dynamicPressureReference: 'Incompressible dynamic pressure, definition',
      pumpingPowerRatioReference:
        'Pumping power as a fraction of heat carried (volume flow cancels)',
      steadyFlowEnergyReference:
        'Steady-flow energy equation for a single-phase stream',
      massConservationReference:
        'White, Fluid Mechanics — control-volume mass conservation for uniform normal velocity and constant density at an opening',
      steadySinglePhaseAssumption:
        'Steady single-phase flow with no work and no phase change.',
      cpAtInletAssumption: 'c_p is evaluated at the inlet temperature.',
      massWeightedRiseAssumption:
        'The rise is the mass-flow-weighted outlet mean minus the inlet.',
      incompressibleReferenceSpeedAssumption:
        'Incompressible flow; U is the reference speed.',
      incompressibleSinglePhaseAssumption: 'Incompressible single-phase flow.',
      pressureDropWholeRegionAssumption:
        'dp is the drop across the whole fluid region.',
    },
    jumpToRelation: 'Open relations for {{quantity}} in {{region}}',
    jumpToEarlierStep: 'Open earlier relation: {{relation}}',
    seeRelation: 'See relation',
    relationsChip: 'Relations',
    relationNotEvaluated: 'Relation not evaluated',
    relationError: {
      generic: 'This relation could not be calculated from the saved values.',
      missingValue: 'Missing value: {{symbols}}.',
      invalidSymbol: '{{symbol}} is not part of this relation.',
      solveFailed: 'Could not solve for {{symbol}}.',
      noRealValue: 'No real value of {{symbol}} satisfies this relation.',
    },
    thermalRelation: {
      surface_heat_flux: 'Surface heat flux',
      convection_heat_rate: 'Convection heat rate',
      conduction_1d: 'One-dimensional conduction',
      heat_rate_from_rise: 'Heat carried by coolant',
      thermal_resistance: 'Thermal resistance',
      thermal_resistance_series: 'Series thermal resistance',
      conduction_resistance: 'Conduction resistance',
      biot_number: 'Biot number',
      nusselt_number: 'Nusselt number',
      colburn_j: 'Colburn factor',
      exchanger_effectiveness: 'Exchanger effectiveness',
      effective_film_coefficient: 'Effective film coefficient',
      pumping_power_ratio: 'Pumping power ratio',
      pipe_nusselt_dittus_boelter: 'Dittus–Boelter pipe correlation',
      axial_stress: 'Axial stress',
      shear_stress: 'Shear stress',
      bearing_stress: 'Bearing stress',
      net_section_stress: 'Net-section stress',
      tearout_stress: 'Tear-out stress',
      eccentric_bending_stress: 'Eccentric bending stress',
      yield_factor: 'Yield factor',
      bolt_separation_load: 'Bolt separation load',
      bolt_clamp_load: 'Bolt clamp load',
      friction_slip_capacity: 'Friction slip capacity',
      beam_bending_stress: 'Beam bending stress',
      cantilever_deflection: 'Cantilever deflection',
      simply_supported_deflection: 'Simply supported beam deflection',
      axial_extension: 'Axial extension',
      euler_buckling_pinned: 'Pinned-column buckling load',
      slenderness_ratio: 'Slenderness ratio',
      beam_first_bending_mode: 'First beam bending frequency',
      rod_first_axial_mode: 'First rod axial frequency',
      dynamic_pressure: 'Dynamic pressure',
      reynolds_number: 'Reynolds number',
      skin_friction_one_seventh: 'Flat-plate skin friction',
      friction_velocity: 'Friction velocity',
      first_cell_height: 'First cell height for target y+',
      drag_from_coefficient: 'Drag from coefficient',
      lift_from_coefficient: 'Lift from coefficient',
      sphere_drag_schiller_naumann: 'Sphere drag correlation',
      thin_airfoil_lift: 'Thin-airfoil lift',
      sudden_expansion_loss: 'Sudden-expansion loss',
      duct_friction_laminar: 'Laminar duct friction',
      pipe_pressure_drop_laminar: 'Laminar pipe pressure drop',
      pipe_pressure_drop_blasius: 'Turbulent pipe pressure drop (Blasius)',
    },
    thermalRelationNote: {
      thermal_resistance_series:
        'Each member has the same cross-sectional area.',
      biot_number: 'Below 0.1, the solid can be treated as one temperature.',
      exchanger_effectiveness:
        'Fraction of the maximum possible heat transfer.',
      pipe_nusselt_dittus_boelter:
        'Approximate correlation; prefer Gnielinski when applicable.',
    },
    calculatedResults: 'Hand Calc results',
    simulationResults: 'Simulation results',
    simulationAndDerivedResults: 'Simulation results and AI derivations',
    noMatchingRunValue: 'No matching run value',
    noHandCalcResult: 'No hand calculation',
    moreRunResults: 'Other simulation results',
    uncheckedOutputs: 'Run outputs with no check',
    uncheckedOutputsHelp:
      'Values the run reports that no filed relation checks. Some have no independent hand calculation at all — a peak temperature is a maximum over a field, not something a closed form produces — and the rest are gaps worth filling.',
    uncheckedOutputsHelpFlow:
      'Values the run reports that no filed relation checks. Some have no independent hand calculation at all — a peak wall pressure is a maximum over a surface, not something a closed form produces — and the rest are gaps worth filling.',
    uncheckedOutputsHelpStructural:
      'Values the run reports that no filed relation checks. Some have no independent hand calculation at all — a peak stress is a maximum over a field, not something a closed form produces — and the rest are gaps worth filling.',
    uncheckedOutputsHelpOther:
      'Values the run reports that no filed relation checks. Some have no independent hand calculation at all, and the rest are gaps worth filling.',
    /** Localized tooltip bodies for UncheckedFact.kind (+ known quantities). */
    uncheckedReason: {
      declaredInput:
        'You declared this, so comparing it against itself would always agree. The check worth making is the other way round: solve a relation for it from the run’s outputs and see whether the run honoured it.',
      noClosedForm: {
        temperature_max:
          'A nodal maximum over an arbitrary geometry has no closed form. The nearest relation, lumped capacitance temperature, gives a body-average and only below Bi 0.1 — and comparing a whole-body average against a hot spot would read as a disagreement exactly when a peak is worth reporting. Checking the peak needs the run’s own field, not a hand calc.',
        peak_temperature:
          'A peak over the run (or over the field) has no closed form. The nearest relation, lumped capacitance temperature, gives a body-average and only below Bi 0.1 — comparing that average against a hot spot reads as a disagreement exactly when the peak is worth reporting. Checking it needs the run’s own field, not a hand calc.',
        temperature_min:
          'The same as a peak temperature and for the same reason: an extremum over a field, not a quantity a closed form produces.',
        temperature_avg:
          'Lumped capacitance temperature is the real candidate — for a body below Bi 0.1 its T(t) is the volume average — but it publishes temperature, so no relation’s result quantity matches this one. Repointing it is a follow-up rather than a line in this table.',
      },
    },
    declaredInputs: 'Inputs you declared',
    backSolveHint: 'Check this by solving {{relation}} for it',
    declaredInputsHelp:
      'Boundary conditions and material properties you set. Comparing one against itself would always agree, so these are not gaps. The useful check is the other way round: solve a relation for the value you declared and see whether the run honoured it.',
    whyNoHandCalc: 'Why no hand calculation?',
    noHandCalcHelp:
      'These are values the run reports, but no independent relation is filed to check them. A matching name alone does not make a valid comparison.',
    addHandCalc: 'Add Hand Calc',
    addHandCalcAgent: 'Agent',
    addHandCalcLabel:
      'Ask the agent to add a hand-calc relation for {{quantity}} in {{region}}',
    addHandCalcChatTitle: 'Hand Calc · {{quantity}} · {{region}}',
    addHandCalcChatPrompt:
      'Please draft a Hand Calc check for {{quantity}} on {{region}}. The run reports {{value}} {{unit}}, and no relation checks it yet. Propose a suitable relation (or a free equation if nothing in the catalogue fits) and save it if I agree. Answer in plain language; do not name tools or wire field names.\n\n{{toolContext}}',
    askRegionHeat: 'Ask about region heat and signs',
    askRegionHeatAgent: 'Agent',
    askRegionHeatLabel:
      'Ask the assistant to explain these region heat balances, the Sankey, and the sign convention',
    askRegionHeatTitle: 'Region heat · signs',
    askRegionHeatNoTerms: 'no terms listed',
    askRegionHeatNoLedgers: 'No region heat balances are shown on this page.',
    askRegionHeatUnknownTerm: 'heat rate',
    askRegionHeatCoverageComplete: 'all boundaries reported',
    askRegionHeatCoverageOneSided: 'heat only one way',
    askRegionHeatCoverageIncomplete: 'some boundaries missing',
    askRegionHeatCoverageLegacy: 'older partial ledger',
    askRegionHeatCoverageDerived:
      'Coverage: not assessed — the region closes by construction, because a balance derived one of its terms from the others',
    askRegionHeatLedgerLine:
      '- {{region}} ({{coverage}}): in {{inbound}} {{unit}}, out {{outbound}} {{unit}}, remainder {{remainder}} {{unit}}; terms (positive into the region): {{terms}}',
    askRegionLedgerLineNotAssessed:
      '- {{region}} (not assessed): {{lines}} reports no value, so its totals cover only part of the boundary and are not a balance. {{side}}Terms that are reported (positive into the region): {{terms}}',
    askRegionNotAssessedNoInflow: 'Nothing is reported entering. ',
    askRegionNotAssessedNoOutflow: 'Nothing is reported leaving. ',
    askRegionHeatPrompt:
      'Please explain the region heat balances and Sankey on this page.\n\n{{ledgers}}\n\nExplain the sign convention: positive means heat into the region; Sankey band widths follow those signed rates; remainder = in − out; Heating/Cooling prefers average temperature change when shown. Then say what these numbers mean for this run — which assessed regions do not close, and, for any region marked not assessed, which boundary reports no value (do not call it unclosed), and what to check next. Answer in plain language. Do not redraw the Sankey, and do not name tools, coverage enums, or wire field names.\n\n{{toolContext}}',
    askRegionMass: 'Ask about region mass flow and signs',
    askRegionMassLabel:
      'Ask the assistant to explain these region mass-flow balances and the sign convention',
    askRegionMassTitle: 'Region mass flow · signs',
    askRegionMassNoLedgers:
      'No region mass-flow balances are shown on this page.',
    askRegionMassUnknownTerm: 'mass flow',
    askRegionMassCoverageOneSided: 'flow only one way',
    askRegionMassPrompt:
      'Please explain the region mass-flow balances on this page.\n\n{{ledgers}}\n\nExplain the sign convention: positive means flow into the region; remainder = in − out. Then say what these numbers mean for this run — which assessed regions do not close, and, for any region marked not assessed, which opening reports no value (do not call it unclosed), and what to check next. Answer in plain language. Do not name tools, coverage enums, or wire field names.\n\n{{toolContext}}',
    askRelationAgent: 'Agent',
    askRelationEquation: 'Ask about this equation',
    askRelationEquationLabel:
      'Ask the assistant to explain the equation and context for {{title}}',
    askRelationEquationTitle: 'Relation equation · {{title}}',
    askRelationEquationPrompt:
      'Please explain this Hand Calc relation on the page.\n\nName: {{title}}\nWhere: {{scope}}\nKind: {{source}}\nEquation: {{tex}}\nInputs shown: {{givens}}\nResult: {{result}}\n\nWhat does this equation mean here, what do the symbols stand for from the numbers above, and what limits apply? Answer in plain language. Do not restate every input row, do not name tools or ids, and do not change the relation unless asked.\n\n{{toolContext}}',
    askRelationBacksolve: 'Ask about backsolve',
    askRelationBacksolveLabel:
      'Ask the assistant whether a backsolve of {{title}} would help verify the run',
    askRelationBacksolveTitle: 'Backsolve · {{title}}',
    askRelationBacksolvePrompt:
      'Please advise whether turning this Hand Calc relation around would help verify the run.\n\nName: {{title}}\nWhere: {{scope}}\nEquation: {{tex}}\nHow it runs now: {{direction}}\nInputs shown: {{givens}}\nResult: {{result}}\nComparison: {{comparison}}\n\nExplain what could be solved for instead, and how that would check the run or a value I declared. Say clearly when turning it around is NOT worth doing — for example when the forward check already agrees inside its band, when no useful unknown exists, or when it would only restate a declared input. Do not request or save a change unless I ask after your explanation. Answer in plain language; do not name tools or wire field names.\n\n{{toolContext}}',
    askRelationVerdict: 'Ask about this verdict',
    askRelationVerdictLabel:
      'Ask the assistant to explain the verdict and assumptions for {{title}}',
    askRelationVerdictTitle: 'Relation verdict · {{title}}',
    askRelationVerdictPrompt:
      'Please explain the verdict on this Hand Calc relation.\n\nName: {{title}}\nWhere: {{scope}}\nEquation: {{tex}}\nResult: {{result}}\nComparison: {{comparison}}\nAssumptions: {{assumptions}}\nReference: {{reference}}\nApproval: {{approval}}\nProblem: {{error}}\n\nExplain what the page is saying — agreement vs disagreement with the allowed band, assumptions the run has not confirmed (for example that all source heat leaves by this path), and that approving the relation is separate from verifying the run. Say what is confirmed, what is not, and one next check. Answer in plain language; do not name tools or wire field names.\n\n{{toolContext}}',
    askRelationToolContext:
      'Context for your tools only — do not repeat to me: study {{studyId}}, design point {{dpId}}, attempt {{attemptId}}. Read the open design point’s hand-calc record if you need more detail.',
    addHandCalcToolContext:
      'Context for your tools only — do not repeat to me: study {{studyId}}, design point {{dpId}}, attempt {{attemptId}}, fact to check {{factId}}. Read the open design point’s hand-calc record if you need more detail.',
    askRelationSourceLibrary: 'Catalogue relation',
    askRelationSourceOther: 'Custom relation',
    askRelationNoTemplate: 'none (free / structural)',
    askRelationNoGivens: 'none shown',
    askRelationNoComparison: 'no comparison on this card',
    askRelationNoBand: 'no allowed band',
    askRelationBandPct: '±{{value}}% allowed',
    askRelationBandUnknown: 'band not scored',
    askRelationWithinBand: 'inside the band',
    askRelationOutsideBand: 'outside the band',
    askRelationComparisonLine: 'difference {{delta}} ({{band}}; {{within}})',
    askRelationNoAssumptions: 'none listed',
    askRelationNoReference: 'none',
    askRelationNoAttach: 'direction cannot be changed on this card',
    askRelationApproved: 'approved by a reviewer',
    askRelationNotApproved: 'not approved yet',
    askRelationNoSolveFor: 'no unknown chosen',
    askRelationSolvingFor: 'solving for {{symbol}}',
    askRelationNoTarget: 'no engineer target',
    askRelationDirectionForward:
      'forward — solving for the equation’s own answer',
    askRelationDirectionLine:
      '{{direction}}; {{solveFor}}; held value {{target}}',
    askRelationNoError: 'none',
    openRelations: 'View relations',
    noReferenceBand: 'No reference band',
    noReferenceBandHelp:
      'This relation has no allowed difference to check against. Blue marks a measured difference, not a pass or fail.',
    balanceChecks: 'Region balance checks',
    balanceChecksHelp:
      'Both numbers describe the same region: heat entering or generated there, and heat leaving it. Their difference is unaccounted heat, not a measured source or sink.',
    balanceChecksHelpMass:
      'Both numbers describe the same region: mass flow entering it, and mass flow leaving it. Their difference is unaccounted flow, not a measured source or sink.',
    balanceChecksHelpOther:
      'Both numbers describe the same region: what enters it or is generated there, and what leaves it. Their difference is unaccounted, not a measured source or sink.',
    symbolHelp:
      'This symbol means {{quantity}} in this relation. Choose a reported value or type your own.',
    symbolHelpLabel: 'What {{symbol}} means',
    editInput: 'Use your value',
    saveInput: 'Save',
    chooseRunValue: 'Choose run value',
    useSourceValue: 'Use source value',
    chooseSourceValue: 'Choose source value',
    sourceGroup: {
      run: 'From the run',
      handCalc: 'From hand calc',
    },
    circularReference: 'circular reference',
    circularReferenceHelp:
      'Disabled options would create a circular reference between relations.',
    catalogueReference: 'Reference notes',
    reportedIn: 'Total in',
    reportedOut: 'Total out',
    balanceHeating: 'Heating',
    balanceCooling: 'Cooling',
    /** Short ΔT label on region balance rows; `<sub>` typesets the subscript. */
    balanceDeltaTAvg: 'ΔT<sub>avg</sub>',
    balanceHeatRoleDeltaHelp:
      'Heating / Cooling follows ΔT_avg when it is shown: +ΔT is Heating (warmed), −ΔT is Cooling (cooled).',
    balanceHeatRoleLedgerHelp:
      'No ΔT_avg on this region — Heating / Cooling follows the heat ledger: more watts in than out is Heating.',
    balanceHeatRoleDeltaVsLedgerHelp:
      'Heating / Cooling follows ΔT_avg (temperature), not the watt columns. A region can warm (+ΔT) while heat leaves — the badge names the temperature change; the totals are the heat ledger.',
    balanceOutflowTo: '→ {{region}}',
    balanceInflowFrom: '← {{region}}',
    balanceSideOrigin: {
      from_run: 'Reported from run',
      agent_cited: 'AI-cited',
      ai: 'Derived (AI)',
      mixed: 'Mixed: run + AI',
      balance: 'Derived from a balance',
      declared: 'Declared',
      other: 'Not from run',
    },
    ledgerTerms_one: 'The {{count}} term in this balance',
    ledgerTerms_other: 'All {{count}} terms in this balance',
    ledgerTermsIn_one: '{{count}} inflow term',
    ledgerTermsIn_other: 'All {{count}} inflow terms',
    ledgerTermsOut_one: '{{count}} outflow term',
    ledgerTermsOut_other: 'All {{count}} outflow terms',
    ledgerOneSided:
      'One-sided: every term runs the same way, so nothing modelled carries this amount out (or in). The whole remainder is unaccounted.',
    ledgerIncomplete_one:
      'Not assessed: {{lines}} reports no value, so this is a sum over part of the region’s boundary. Missing is not zero.',
    ledgerIncomplete_other:
      'Not assessed: {{count}} boundaries ({{lines}}) report no value, so this is a sum over part of the region’s boundary. Missing is not zero.',
    ledgerLegacy:
      'Built before region ledgers: these are the largest single term each way, not the region’s totals.',
    ledgerDerived:
      'Closes only by construction: a balance wrote one of its terms from the others, so the run measured nothing here that could disagree. Not assessed.',
    ledgerOrigin: {
      solver: 'from run',
      declared: 'declared',
      derived: 'derived (AI)',
      agent_cited: 'AI-cited',
      engineer: 'engineer-typed',
    },
    ledgerAgentCited_one:
      'Includes {{count}} AI-cited term: the AI filed this number with a citation where the run had none. It is not from the run.',
    ledgerAgentCited_other:
      'Includes {{count}} AI-cited terms: the AI filed these numbers with citations where the run had none. They are not from the run.',
    ledgerAgentGroup:
      'AI-made group: the AI chose which parts this region holds, so this balance is over a boundary the AI drew, not one the case defines.',
    ledgerAgentReshaped:
      'Regrouped by the AI: the AI moved parts into or out of this region, so its boundary is not the one the case defines.',
    runReports: 'The run reports',
    assumptions: 'Assumptions',
    noAssumptions: 'No relation on this run binds a number you can change.',
    saving: 'Saving…',
    saved: 'Saved',
    reset: 'Reset your edits',
    model: 'Whole model',
    regions: 'Regions',
    region: 'Region',
    relation: 'Relation',
    runValueUnavailable: 'Run value unavailable',
    regionsFoot:
      'Interfaces exist because two regions touch, so they are not created by hand.',
    filedCount_one: '{{count}} filed',
    filedCount_other: '{{count}} filed',
    filedHere_one: '{{count}} relation here',
    filedHere_other: '{{count}} relations here',
    noneHere:
      'Nothing is filed at this region yet. Add a relation to start one.',
    ungroup: 'Ungroup',
    removeRejected: 'Remove rejected item',
    gap: 'Does not close',
    given: 'Given',
    step: 'Step {{position}} of {{total}}',
    result: 'Result',
    net: {
      in: 'Net into region',
      out: 'Net out of region',
    },
    netRateHelp:
      'Positive means more enters this region than leaves it. Negative means more leaves than enters. A steady run should be near zero.',
    derivedBalanceWarning:
      'One boundary value comes from another region’s balance. This sum is separate from the solver’s energy check.',
    rightClickUnits: 'Right-click to change display units.',
    proposed: 'Agent-written',
    proposedHelp:
      'The agent wrote this equation because no saved relation fits. Its units were checked, but no engineer has reviewed it. It is excluded from the report.',
    compareAgainst: 'Compare against',
    band: '±{{value}}%',
    comparisons: 'Hand calculation against the run',
    quantity: 'Quantity',
    calculated: 'Calculated',
    observed: 'Run',
    difference: 'Difference',
    differenceNotAssessed: 'Not assessed',
    differenceNotAssessedHelp:
      'A boundary of this region reports no value, so the totals cover only part of it. No difference is shown until every boundary reports.',
    bandColumn: 'Reference band',
    relationBandHelp:
      'Allowed difference set by this relation: the calculation agrees with the run inside ±{{value}}%.',
    balanceBandHelp:
      'The difference between total in and total out must be within 1% of the larger total. Positive means net into the region (or system); negative means net out of it.',
    noComparisons:
      'Nothing on this run is comparable to the relations filed here.',
    loading: 'Reading this run’s hand calculation…',
    loadFailed: 'The hand calculation could not be read.',
    unavailable: 'There is no hand calculation for this run.',
    noSavedRecord: 'No hand calculation has been saved for this run yet.',
    retry: 'Try again',
    editFailed:
      'That change was refused, so nothing was saved. The calculation below is unchanged.',
    markReviewFailed:
      'Approving “{{relation}}” was refused. Nothing was saved.',
    clearReviewFailed:
      'Removing approval of “{{relation}}” was refused. Nothing was saved.',
    editOnAnotherRun:
      'The change was saved, but this point has moved to a newer run. Reopen it to read the saved calculation.',
    aiDraft: 'Drafted by the AI and not edited since.',
    editedBy: 'Last edited by {{name}}.',
    editedByYou: 'Last edited by you.',
    draftedOnAnotherRun:
      'This calculation was written against an earlier run of this point.',
    regenerate: 'Regenerate',
    regenerating: 'Drafting…',
    regenerateTooltip:
      'Asks the advisor to draft a new hand calculation for this run. Replaces the catalogue relations, assumptions, typed inputs, and comparison targets saved here. Structural balances from the case stay.',
    regenerateTooltipEdited:
      'Asks the advisor to draft a new hand calculation for this run. Replaces everything saved here — including your typed values, targets, and groups — with the new draft. Structural balances from the case stay.',
    regenerateTitle: 'Draft this hand calculation again?',
    regenerateWarning:
      'The AI writes a new calculation for this run, and the one on screen is replaced by it. There is no way back to the current draft.',
    regenerateWarningEdited:
      'The AI writes a new calculation for this run. Everything saved here is replaced by it, your own values, targets and groups included, and there is no way back to them.',
    regenerateKeep: 'Keep this one',
    regenerateConfirm: 'Replace it',
    regenerateFailed:
      'The hand calculation could not be drafted again, so the saved one below is unchanged.',
    askAssumptionSuggestions: 'Suggest values',
    askAssumptionSuggestionsLabel:
      'Ask the assistant to suggest values for these assumptions',
    askAssumptionSuggestionsTitle: 'Assumption values',
    askAssumptionSuggestionsPrompt:
      'Please suggest values for the Hand Calc assumptions listed below.\n\nCurrent numbers:\n{{facts}}\n\n{{editableCount}} of these can be typed on the page.\n\nFor each editable number that needs a better value, propose one grounded in engineering judgment for this kind of run (flow, conjugate heat transfer, or FEA thermal / structural as fits the open study). Prefer published material libraries and first-principles estimates over ad-hoc guesses. State whether each suggestion is conservative or optimistic for the check it supports, and whether it is physically plausible or would be unphysical for this setup. Do not invent wire field names. Do not save changes unless I ask after your explanation.\n\n{{toolContext}}',
    askAssumptionValue: 'Suggest value',
    askAssumptionValueLabel:
      'Ask the assistant to suggest a value for {{quantity}} in {{region}}',
    askAssumptionValueTitle: 'Assumption · {{quantity}} · {{region}}',
    askAssumptionValuePrompt:
      'Please suggest a value for this Hand Calc assumption.\n\nQuantity: {{quantity}}\nRegion: {{region}}\nCurrent value: {{value}}\nRelation: {{relation}}\nSymbol: {{symbol}}\n\nPropose a number grounded in engineering judgment for this kind of run (flow, conjugate heat transfer, or FEA thermal / structural as fits the open study). Prefer published material libraries and first-principles estimates. Say whether the suggestion is conservative or optimistic for the check it supports, and whether it is physically plausible or would be unphysical here. Do not invent wire field names. Do not save a change unless I ask after your explanation.\n\n{{toolContext}}',
    askAssumptionNoFacts: 'none listed yet',
    askAssumptionToolContext:
      'Context for your tools only — do not repeat to me: study {{studyId}}, design point {{dpId}}, attempt {{attemptId}}. Read the open design point’s hand-calc record if you need more detail.',
    addRelation: 'Add relation',
    relationLimit:
      'This hand calculation holds {{max}} relations, the most one record can hold. Remove one to add another.',
    removeRelation: 'Remove',
    removeRelationLabel: 'Remove {{name}} from this design point',
    confirmRemoveRelation: 'Remove it',
    cancelRemoveRelation: 'Keep',
    catalogue: 'Catalogue relations',
    catalogueCount: '{{applicable}} of {{total}} apply here',
    chooseRelation: 'Choose a relation',
    chooseFact: 'Choose a value',
    noOffers: 'No further relation applies at this region.',
    optionalResult: 'optional — bind it to compare against the run',
    // Menu choice that clears a result binding (Radix has no empty SelectItem).
    leaveUnbound: 'Optional — leave unbound',
    missingBinding: 'This run reports no value in the unit this symbol needs.',
    needsTypedValue:
      'The run has no value for {{symbols}}. Type one to add it.',
    attach: 'Add it',
    typeValue: 'Type a value',
    typedHere: 'Typed here, filed as {{quantity}} at this region',
    gapQuantity: '{{quantity}} does not close',
    gapTitle:
      'Entering + declared here − leaving. A negative value means net out.',
    changeDirection: 'Change direction',
    directionTitle: 'Which way to run this relation',
    directionHelp:
      'Solve the equation as written, or choose another symbol to solve for. For the latter, use either a run value or your target.',
    directionForward: 'Solve for <sym/>, the equation’s own answer',
    directionBackwards: 'Turn it around',
    solveFor: 'Solve for',
    chooseUnknown: 'Choose a symbol',
    holdFromRun: 'Hold <sym/> at a value the run reports',
    useRunValue: 'Use the run’s value',
    noRunValue: 'This run reports nothing that can hold <sym/>.',
    holdFromTarget: 'Hold <sym/> at a target you set [{{unit}}]',
    targetReason: 'Where that target comes from',
    useTarget: 'Use my target',
    unitFor: 'Unit for {{quantity}}',
    flowTitle: 'Where the heat goes',
    flowView: 'Heat-flow view',
    flowWholeModel: 'Whole model',
    flowRegions: 'Regions',
    flowWholeScopeHelp:
      'The whole-model check uses declared heat and external boundary rates. Internal transfers cancel.',
    flowRegionScopeHelp:
      'Each region has its own balance, over every term on its boundary. Each interface is counted once, so the drawn region remainders add up to the whole-model remainder; a region that closes within 1% is not drawn.',
    // Single-body thermal FEA (and any graph with one heat-carrying part):
    // Regions collapses to the same picture as Whole model — CHT-style
    // per-volume/interface bands need multiple bodies or interface transfers.
    flowRegionSingleBodyHelp:
      'This run has one heat-carrying body, so Regions matches Whole model. Per-body bands appear when the mesh has multiple volumes (or CHT regions/interfaces) with face ownership on the result.',
    flowCaption:
      'Bands combine declared heat input and run-reported rates ({{unit}}). Orange shows a derived balance remainder, not a measured flow.',
    flowSource: 'Declared heat input',
    flowEnvironment: 'External boundary',
    flowMissingIn: 'Unaccounted inflow',
    flowMissingOut: 'Unaccounted outflow',
    flowMoreLeaves: 'More leaves than enters or is generated here',
    flowMoreEnters: 'More enters or is generated here than leaves',
    flowNotAssessed:
      'Remainder of a partial sum: a boundary of this region reports no value',
    flowLegend: 'Energy-flow legend',
    flowLegendSource: 'Source · declared heat input',
    flowLegendTransfer: 'Transfer · region-to-region heat',
    flowLegendSink: 'Sink · external boundary',
    flowLegendDerived: 'AI-derived or AI-cited · not solver-reported',
    flowLegendBalanceDerived: 'Derived from a balance, not measured',
    flowDerivedByAgent:
      'Derived by AI from run inputs; not solver-reported or reviewed',
    flowDerivedByBalance: 'derived from a balance, not measured',
    flowDerivedCaution:
      'Boundary rate is AI-derived, not measured by the solver.',
    flowBalanceDerivedCaution:
      'Grey bands are rates a balance worked out because the run reported none; a region that only closes on them is not assessed.',
    flowCitedByAgent:
      'Filed by AI with a citation; not solver-reported or reviewed',
    flowCitedCaution: 'Some rates are AI-cited, not measured by the solver.',
    // `<sub>` renders as a subscript in the tooltip and the list.
    flowDetail: {
      temperature_change: 'ΔT<sub>avg</sub> from initial',
      mass_flow: 'Mass flow ṁ',
      inlet_temperature: 'Inlet T<sub>in</sub>',
      inlet_velocity: 'Inlet speed U<sub>in</sub>',
      outlet_temperature: 'Outlet bulk T<sub>out</sub>',
      outlet_velocity: 'Outlet mean speed U<sub>out</sub> = ṁ/(ρA)',
    },
    /** Whole-model ΔT when volume-weighted from regions, not published. */
    flowDetailEstimated: 'estimated from regions',

    flowLegendGap:
      'Unaccounted inflow or outflow · balance remainder, not a measured flow',
    flowGapHelp:
      'The reported heat entering and leaving this region differs. This band shows the missing amount and its direction; it is not a real heat source or sink.',
    assumptionEditable:
      'Editable assumption. You or the agent can change this saved hand-calculation value.',
    assumptionReadOnly:
      'Read-only evidence emitted by the solver or derived from another recorded fact.',
    flowEmpty: 'This run reports no rates to draw.',
    flowAwaitingBoundary:
      'The case declares heat input, but this run reports no heat rate at an inlet or outlet. The agent can edit assumptions and relations, not measured boundary rates, so the full path cannot be drawn yet.',
    flowUnreportedBoundaries:
      'Case boundaries without a measured heat rate: {{names}}.',
    flowTooltip: '{{label}}: {{value}} {{unit}}',
    flowTable: 'Read the flows as a list',
    flowLoop: 'not drawn: it would send the flow back where it came from',
    radarTitle: 'How far each one sits from the run',
    radarCaption:
      'Distance from the run, unsigned, against each relation’s published band.',
    radarDeviation: 'Distance from the run',
    radarBand: 'Published band',
    radarNoBand: 'no published band',
    radarTooltip: '{{label}}: {{value}}% from the run, band ±{{band}}%',
    radarTooltipNoBand: '{{label}}: {{value}}% from the run',
    kind: {
      model: 'Model',
      body: 'Solid',
      fluid: 'Fluid',
      group: 'Group',
      line: 'Boundary',
    },
    kindHelp: {
      model: 'The whole-model control volume — every solid and fluid together.',
      body: 'One solid part from the case — not every solid added together. The whole-model row is the system balance.',
      fluid:
        'One fluid region from the case — not every fluid added together. The whole-model row is the system balance.',
      group:
        'A named group of parts treated as one control volume, not each member separately.',
      line: 'One boundary or interface on the mesh.',
    },
    provenance: {
      run: 'from the run',
      library: 'from the library',
      cited: 'cited by the AI',
      engineer: 'typed by an engineer',
      engineerNamed: 'typed by {{name}}',
      engineerYou: 'typed by you',
      step: 'from an earlier step',
      target: 'your target',
    },
    direction: {
      fromRun: 'From the run',
      fromTarget: 'From your target',
    },
    op: {
      attach: 'Relation {{position}}',
      reparent: 'Grouping {{position}}',
      value: 'Value {{position}}',
      propose: 'Agent equation {{position}}',
    },
    quantityName: {
      area: 'Area',
      volume: 'Volume',
      mass: 'Mass',
      density: 'Density',
      kinematic_viscosity: 'Kinematic viscosity',
      specific_heat: 'Specific heat',
      velocity: 'Velocity',
      pressure: 'Pressure',
      pressure_drop: 'Pressure drop',
      total_pressure_drop: 'Total pressure drop',
      mass_flow: 'Mass flow',
      mass_flow_net: 'Net mass flow',
      volumetric_flow: 'Volumetric flow',
      temperature: 'Temperature',
      temperature_max: 'Maximum temperature',
      temperature_min: 'Minimum temperature',
      temperature_avg: 'Average temperature',
      ambient_temperature: 'Ambient temperature',
      initial_temperature: 'Initial temperature',
      temperature_difference: 'Temperature difference',
      thermal_conductivity: 'Thermal conductivity',
      film_coefficient: 'Film coefficient',
      heat_rate: 'Heat rate',
      heat_rate_net: 'Heat-rate balance',
      heat_flux: 'Heat flux',
      force: 'Force',
      drag_force: 'Drag force',
      lift_force: 'Lift force',
      force_net: 'Net force',
      preload_force: 'Preload force',
      displacement: 'Displacement',
      von_mises_stress: 'Von Mises stress',
      yield_strength: 'Yield strength',
      bearing_stress: 'Bearing stress',
      bending_stress: 'Bending stress',
      biot_number: 'Biot number',
      colburn_factor: 'Colburn factor',
      drag_coefficient: 'Drag coefficient',
      dynamic_pressure: 'Dynamic pressure',
      effectiveness: 'Effectiveness',
      first_cell_height: 'First cell height',
      hydraulic_diameter: 'Hydraulic diameter',
      frequency: 'Frequency',
      friction_factor: 'Friction factor',
      friction_velocity: 'Friction velocity',
      lift_coefficient: 'Lift coefficient',
      loss_coefficient: 'Loss coefficient',
      nusselt_number: 'Nusselt number',
      pumping_power_ratio: 'Pumping power ratio',
      reynolds_number: 'Reynolds number',
      safety_factor: 'Safety factor',
      shear_stress: 'Shear stress',
      skin_friction_coefficient: 'Skin friction coefficient',
      slenderness_ratio: 'Slenderness ratio',
      stress: 'Stress',
      thermal_resistance: 'Thermal resistance',
      thermal_time_constant: 'Thermal time constant',
      time_period: 'Time period',
      volumetric_heat_density: 'Volumetric heat density',
      temperature_change: 'Temperature change from initial',
      thickness: 'Thickness',
      length: 'Length',
      angle_of_attack: 'Angle of attack',
      prandtl: 'Prandtl number',
      elastic_modulus: 'Elastic modulus',
      buckling_load: 'Critical buckling load',
      buckling_load_factor: 'Buckling load factor',
      second_moment_area: 'Second moment of area',
      section_modulus: 'Section modulus',
      moment: 'Moment',
      stiffness_fraction: 'Joint stiffness fraction',
      friction_coefficient: 'Friction coefficient',
      stanton_number: 'Stanton number',
      wall_distance_ratio: 'Wall-distance ratio',
    },
  },
  generatedHandCalc: {
    exportSelectionTitle: 'Choose calculations for this export',
    exportSelectionHelp:
      'This report can include calculations from up to 8 points, with 32 comparison rows and 32 references in total. Select the points to include, or export without live calculations. All solver results remain included. Your session edits are kept.',
    exportSelectionLimit:
      'Reduce your selection to at most 8 points, 32 comparison rows and 32 references.',
    exportRowCount: 'Comparison rows: {{count}}',
    exportSelected: 'Export selected calculations',
    exportWithoutCalculations: 'Export without live calculations',
    cancel: 'Cancel',
    notGenerated:
      'No saved hand calculation is available for this run. Open the design point to create one.',
    liveOnly:
      'The design point’s saved hand calculation, replayed against this run.',
    reportTitle: 'Hand-calculation comparisons',
    assumptions: 'Assumptions',
    cause: 'Why: {{text}}',
    empty: 'This run states too little for any sum to be built.',
    dropped: {
      unresolved_target_one:
        '{{count}} boundary condition could not be matched to a part, so it is in no sum',
      unresolved_target_other:
        '{{count}} boundary conditions could not be matched to a part, so they are in no sum',
      contact_pair_one: '{{count}} contact pair could not be matched to a part',
      contact_pair_other:
        '{{count}} contact pairs could not be matched to a part',
      tied_interface_one:
        '{{count}} tied interface could not be matched to a part',
      tied_interface_other:
        '{{count}} tied interfaces could not be matched to a part',
      missing_end_one: '{{count}} line names a part that is not on the graph',
      missing_end_other: '{{count}} lines name a part that is not on the graph',
      duplicate_fact_one:
        '{{count}} number was stated twice for one part in units that do not add, so only the first is shown',
      duplicate_fact_other:
        '{{count}} numbers were stated twice for one part in units that do not add, so only the first of each is shown',
      over_scope_limit_one:
        'This assembly is larger than one response can carry: {{count}} part or boundary is missing, and the sums with it',
      over_scope_limit_other:
        'This assembly is larger than one response can carry: {{count}} parts and boundaries are missing, and the sums with them',
      over_fact_limit_one:
        '{{count}} recorded number did not fit in this response',
      over_fact_limit_other:
        '{{count}} recorded numbers did not fit in this response',
      over_relation_limit_one:
        '{{count}} sum did not fit in this response, so the part it belongs to is not listed',
      over_relation_limit_other:
        '{{count}} sums did not fit in this response, so the parts they belong to are not listed',
    },
    unavailable: 'No sums are built for this run.',
    gaps: 'Where a sum does not close',
    gapTerms: 'Largest in {{inbound}}, largest out {{outbound}}',
    gapTotals: 'In {{inbound}}, out {{outbound}} across all {{count}} terms',
    difference: 'Everything in, less everything out',
  },

  workbench: {
    // ENG-1843 retired the 7-mode rail; what remains here are the compare
    // and statistics surfaces' own strings, plus the `exportPdf*` set the
    // shared `ExportReportButton` primitive reads. The `ab*` / `runA` /
    // `runB` / `deltaBvsA` keys went with the two-run-only compare panel:
    // the comparison takes two OR three picked points now, so a key that
    // spells "A/B" no longer describes what is on screen.
    compare: 'Compare',
    compareTitle: '{{n}} picked design points',
    compareClose: 'Back to table',
    comparePageLabel: 'Run comparison',
    compareClear: 'Clear compare selection',
    compareNeedsTwo:
      'Pick at least two completed runs to compare — from the menus above, or in the table\u2019s compare column.',
    comparePickSlot: 'Compared point {{letter}}',
    comparePickAdd: 'Add a point',
    comparePickRemove: 'Remove {{letter}} from the comparison',
    compareOutputs: 'Outputs (Δ vs A)',
    compareInputsDiffer: 'Inputs that differ',
    compareInputsIdentical:
      'Every input is identical across the compared points — solver, mesh and boundary conditions match.',
    compareInputsNoneShown:
      'No single-value input differs across the compared points. Nested settings such as solver parameters are not compared here and may still differ.',
    compareInput: 'Input',
    compareViewers: 'Result views',
    compareLinkCameras: 'Link the views',
    compareSyncColourScale: 'Sync colour scale',
    compareSyncField: 'Sync field',
    compareSyncProbe: 'Sync line probe',
    compareSyncSectionPlane: 'Sync section plane',
    compareResiduals: 'Convergence',
    compareRun: 'Run {{letter}}',
    residualsLoading: 'Loading residuals…',
    residualsUnavailable: 'No residual history for the compared runs.',
    statsTitle: 'Spread of each output across completed runs',
    statsNumbers: 'Numbers',
    statsDistribution: 'Distribution',
    distributionStrip: '{{label}} across {{n}} usable points',
    distributionMean: 'mean',
    distributionPoint: 'Design point #{{n}} · {{value}}',
    statsEmpty: 'No completed runs with outputs yet.',
    statsExcluded_one:
      'Computed over the {{count}} usable point — {{ids}} excluded.',
    statsExcluded_other:
      'Computed over the {{count}} usable points — {{ids}} excluded.',
    statsReviewFailures: 'Review failures',
    output: 'Output',
    min: 'Min',
    mean: 'Mean',
    max: 'Max',
    spread: 'Spread (σ)',
    exportPdf: 'Export Report (PDF)',
    exportPdfPending: 'Preparing PDF…',
    exportDocxPending: 'Preparing Word document…',
    // The two hints each name what the OTHER document holds, because the two
    // exports are disjoint (ENG-1839) and a reader who takes only one file
    // needs to know a part of the report is in the other.
    exportPdfHint:
      'Compiles the tables and checks — the evidence, without the writeup — and downloads it as a PDF.',
    exportWriteup: 'Export Writeup (PDF)',
    exportWriteupHint:
      'Downloads the writeup on its own, without the tables and checks.',
    exportWriteupDocx: 'Export Writeup (Word)',
    exportWriteupDocxHint:
      'Downloads the writeup as an editable Word document, without the tables and checks.',
    exportWriteupMenu: 'Export',
    pdfFormat: 'PDF',
    docxFormat: 'DOCX',
    retryExportFormat: 'Retry {{format}}',
    exportFormatReady: '{{format}} is ready.',
    exportFormatFailed: '{{format}} could not be prepared. Select to retry.',
    closeReportWriter: 'Close report writer',
  },
  // What the AI retry loop did to this study, read off the attempt chain by
  // `-components/evaluate/ai-retry-log.ts`. Keyed separately from
  // `unusableRuns` because the two banners answer different questions and the
  // failed banner borrows only the state labels.
  aiRetry: {
    regionLabel: 'What AI retry did',
    // No plural pair: the sentence reads the same at 1 and at 20, and ja and
    // zh-TW would carry two identical copies of a distinction neither makes.
    title: 'AI retry recovered {{count}} of the {{total}} runs that failed.',
    titleNone: 'AI retry recovered none of the {{total}} runs that failed.',
    // The subline earns the banner's claim by NAMING the points, so a reader
    // can go and check one. A count on its own would be the same sentence the
    // headline already said.
    subline_one: '{{points}} is in your results because the AI retried it.',
    subline_other:
      '{{points}} are in your results because the AI retried them.',
    sublineNone: 'Here is what the AI tried.',
    show: 'Show what the AI did',
    hide: 'Hide what the AI did',
    // The four outcomes. `attempt` is 1-based and counts the ORIGINAL run, so
    // "attempt 2" is the first retry — the same number `AttemptHistory` shows.
    stateRecovered: 'Recovered on attempt {{n}}',
    stateRetrying: 'Retrying — attempt {{n}} of {{max}}',
    // No ceiling to name: automatic retry is off, so this is a manual retry
    // and there is no further attempt promised.
    stateRetryingNoMax: 'Retrying — attempt {{n}}',
    stateGaveUp: 'AI stopped after attempt {{n}} of {{max}}',
    stateGaveUpNoMax: 'AI stopped after attempt {{n}}',
    // Nothing was spawned: the advisor read the failure and chose not to
    // retry it. Without this a reader cannot tell it from a point the loop
    // never reached.
    stateDeclined: 'AI did not retry this',
    // Both read by `relativeTimeLabel`, which picks between them: the bare
    // formatter returns a unit ("14m") so the preposition can be translated
    // rather than baked in, EXCEPT under a minute where it returns the
    // already-complete word "now" and `ago` would spell "now ago".
    ago: '{{ago}} ago',
    justNow: 'just now',
    // No `sop` or `changesHeading` here: `simopsDesignPoints.attemptHistory`
    // already translates both, and this feature's other surfaces
    // (`AttemptHistory`, `SimDecisionBlock`) render them from there. A second
    // spelling is how one fact ends up worded two ways in one locale.
    footer: 'Every AI retry in this study, newest first.',
  },
  unusableRuns: {
    regionLabel: 'Runs with no usable result',
    // No plural suffixes: the sentence reads the same at 1 and at 20, so a
    // `_one` / `_other` pair would be two keys ja and zh-TW must carry
    // identical copies of for a distinction neither language makes.
    title: '{{count}} of {{total}} design points produced no usable result.',
    outcomeCancelled: 'Cancelled',
    outcomeUnfinished: 'Never finished',
    // The exception to "a terminal study has nothing in flight": this banner's
    // own retry button spawns a run after the study is done.
    outcomeRunning: 'Running',
    // Header toggle. The banner keeps its count row when collapsed — the
    // hide is of the per-row list only, so a report never opens quieter
    // about its failures than it should.
    collapse: 'Collapse',
    expand: 'Expand',
    // Per-row disclosure. Separate from the header's Collapse/Expand: that one
    // hides the whole list, this one opens ONE row's retry detail.
    rowExpand: 'Show what the AI did for design point {{n}} {{label}}',
    rowCollapse: 'Hide the retry detail for design point {{n}} {{label}}',
    // The row's retry state when there is nothing for the advisor to amend —
    // a cancelled point, or one that failed before it ever dispatched a run.
    // Stated rather than left blank, because a blank reads as "not tried yet".
    noRunToAmend: 'Nothing to retry',
  },
  // Keyed under its own namespace rather than under `unusableRuns`: the prompt
  // is a contract with the sim-retry advisor, and ENG-1830's remaining entry
  // points (the failed-mesh panel, the design point detail panel) must be able
  // to send the same words rather than each keeping a near-copy.
  retryChat: {
    chatTooltip: 'Ask the retry advisor about this failure',
    // Labelled here, icon-only in the banner: the detail panel's action row has
    // horizontal room and its neighbours are labelled, so an unlabelled icon
    // would read as the odd one out rather than as a compact list row.
    chatAction: 'Ask advisor',
    chatAria: 'Chat about the failure of design point {{n}} {{label}}',
    // The ids are for the agent, not decoration: it reads the point, its
    // params and its logs through the backend MCP tools rather than from
    // anything pasted here.
    chatPrompt:
      'Design point #{{n}} ({{label}}) of study {{studyId}} produced no usable result. Read design point {{dpId}} — its inputs, its solver settings and its logs — and tell me why it failed and what you would change.',
    // Deterministic, never generated. A 24-point sweep where every failure gets
    // a chat would otherwise spend one title-generation call apiece.
    chatSessionTitle: 'Retry advice — {{label}}',
    retryTooltip: 'Let the AI amend the settings and run this point again',
    retryAria: 'Retry design point {{n}} {{label}} with AI',
    retryAnywayAria:
      'Retry design point {{n}} {{label}} anyway, with the same settings',
  },
  sandbox: {
    noCompleted: 'No completed runs to draw signals from.',
    failedHandCalc:
      'This run stopped before completion. Hand Calc can use its recorded inputs and last-step results, but any difference is diagnostic, not a verified steady-state comparison.',
    failedPlottingSubtitle:
      'Recorded diagnostics from the stopped run. These are partial data, not verified results.',
    dpLabel: 'Design point',
    handInputsTitle: 'Hand inputs',
    solverSignalsTitle: 'Solver signals',
    radarTitle: 'L1 self-consistency radar',
    selfConsistencyTitle: 'Self-consistency check',
    plottingTitle: 'Plotting set',
    plottingSubtitle:
      'DOE + verification — tagged by flow regime and by what backs it today.',
    finalResiduals: 'Final residuals',
    wallYplus: 'Wall y+',
    internalFlowSignals: 'Internal-flow signals',
    min: 'min',
    mean: 'mean',
    max: 'max',
    notEmitted: 'Not emitted on this run.',
    yplusBandsWarning:
      'Area-fraction y+ bands (<5 / 5–30 / 30–100 / >100) are pending BE — min/mean/max alone can mask boundary-layer coverage.',
    legendLive: 'Backed by emitted fields',
    legendNeedsHand: 'Needs one hand input',
    legendUnderDevelopment: 'Under development',
    legendNotEvaluated: 'Not evaluated (insufficient inputs)',
    visibleTilesLabel: 'Showing {{visible}}/{{total}}',
    visibleTilesHeading: 'Sandbox tiles',
    showAll: 'Show all',
    hideAll: 'Hide all',
    allTilesHidden: 'All tiles hidden — pick some from the dropdown above.',
    phase2Stub:
      'Hand inputs + derived quantities land in a follow-up commit on this branch.',
    phase3Stub: 'The 7-axis radar lands in a follow-up commit on this branch.',
    phase4Stub:
      'The self-consistency table (FREE / ID / GOOD badges + Δ / Δ%) lands in a follow-up commit.',
    tiles: {
      handSolverParity: {
        title: 'Hand vs solver comparison',
        pickerDp: 'DP:',
        desc: 'One dot per quantity with the ±5% tolerance shown as a shaded band. Answers "does the sandbox agree with the run" without reading a table.',
        emptyState:
          'Fill in the Hand-Calc panel above to populate the comparison dots.',
        subtitle_one:
          '{{count}} quantity · dot = (hand − solver) / solver · ±{{tolerance}}% band healthy · U inlet velocity · q dynamic pressure · Q volumetric flow · D drag force · C_D drag coefficient',
        subtitle_other:
          '{{count}} quantities · dot = (hand − solver) / solver · ±{{tolerance}}% band healthy · U inlet velocity · q dynamic pressure · Q volumetric flow · D drag force · C_D drag coefficient',
        xAxisLabel: '(hand − solver) / solver (%)',
        yAxisLabel: 'Solver',
        yAxisCaption:
          'Y: (hand − solver) / solver (%) — left of 0 under, right of 0 over',
        tooltipHand: 'Hand',
        tooltipSolver: 'Solver',
        tooltipRatio: 'Ratio',
        tooltipDp: 'DP',
        chartAriaLabel:
          'Hand vs solver comparison dots for {{count}} quantities. Δ% on Y with a ±{{tolerance}}% healthy band. Dot shape: circle inside band, triangle outside, cross beyond 15%.',
        rows: {
          u: 'U',
          q: 'q',
          q_flow: 'Q',
          drag: 'D',
          cd: 'C_D',
        },
        rowsFull: {
          u: 'Inlet velocity',
          q: 'Dynamic pressure',
          q_flow: 'Volumetric flow',
          drag: 'Drag force',
          cd: 'Drag coefficient',
        },
      },
      coeffSettling: {
        title: 'Coefficient settling envelope',
        desc: 'C_D over the last window with C_D band as envelope. Answers "is this number converged or still swinging?"',
      },
      residualHistory: {
        title: 'Residual history overlay',
        desc: 'All DPs on one log axis, so a diverging run separates visibly from the pack instead of hiding in a per-DP tab.',
        emptyState: 'No simulation attached to the picked DP yet.',
      },
      convergenceHistory: {
        title: 'Convergence history',
        desc: 'Any recorded quantity against iteration: the hottest solid, port temperatures, mass flow, interface flux. The residual says how fast a field is still moving; this shows where it actually is, which can keep climbing after the residual has gone flat.',
        emptyState: 'No simulation attached to the picked DP yet.',
      },
      gridConvergence: {
        title: 'Grid convergence (Richardson)',
        desc: 'Response vs mesh refinement with the extrapolated h→0 value. Standard V&V evidence.',
        emptyState: 'GCI analysis not run on this study yet.',
        subtitle:
          '{{response}} · GCI fine {{gciFine}}% · observed order p={{order}}',
        xAxisLabel: 'Grid size h (mm) — coarse → fine',
        extrapLabel: 'h→0',
        tooltipResponse: 'Response',
        levelFine: 'Fine',
        levelMedium: 'Medium',
        levelCoarse: 'Coarse',
        levelOther: 'Level',
        chartAriaLabel:
          'Grid convergence curve over {{levels}} mesh levels for {{response}}. GCI fine {{gci}}%. Reversed X-axis, coarse on the left, fine on the right, with a dashed h→0 extrapolation marker.',
      },
      yplusBands: {
        title: 'y+ coverage bands',
        desc: 'Area fraction of wall in each y+ band. Needs the BE area fractions the sandbox note already flags.',
      },
      carpet: {
        title: 'Carpet plot (2-factor DOE)',
        desc: 'The sweep matrix as a heat grid — velocity × pressure against one response. Reads the DOE the way it was authored.',
        emptyState:
          'Needs a 2-factor sweep with 2–12 unique values on each factor.',
        subtitle: '{{yAxis}} × {{xAxis}} → {{response}}',
        emptyAmbiguous:
          'Two or more runs share a point on this grid, so a cell would have more than one answer. Pick another pair of inputs, or remove the repeated runs.',
        emptyCellTooltip: 'No DP at this input combination',
        pickerX: 'X-axis:',
        pickerY: 'Y-axis:',
        pickerZ: 'Colour by:',
        groupResponses: 'Responses',
        chartAriaLabel:
          'Carpet plot: {{rows}}×{{cols}} heat grid, {{yAxis}} on Y and {{xAxis}} on X, cells coloured by {{response}}.',
      },
      parallelCoords: {
        title: 'X–Y plotter',
        desc: 'Pick any two numeric fields on X and Y; one point per completed DP. Response-vs-response, response-vs-input, or response-vs-DP-order.',
        emptyState: 'Needs a completed DP with at least one numeric result.',
        subtitle: '{{dps}} DPs plotted · one point per completed DP',
        pickerX: 'X-axis:',
        pickerY: 'Y-axis:',
        // Hint shown on hover of the X-axis / Y-axis caption. Double-click
        // swaps the dropdown for a text input with autocomplete filtering
        // the same option list — a shortcut for readers who already know
        // the field they want (ENG-1890).
        axisTitleHint: 'Double-click to type the field name',
        groupMeta: 'Order',
        groupInputs: 'Inputs',
        groupResponses: 'Responses',
        optionDpIndex: 'DP #',
        tooltipDp: 'DP',
        axisInput: 'input',
        axisResponse: 'response',
        chartAriaLabel:
          'X–Y plotter: {{dps}} DPs plotted, {{xLabel}} on X and {{yLabel}} on Y.',
      },
      sensitivityTornado: {
        title: 'Sensitivity tornado',
        desc: 'Response swing per input over the sweep range. Extends the existing sensitivity panel with a hand-calc ghost bar behind each measured bar.',
        emptyState:
          'Sobol sensitivity not computed yet — the study analysis has not run.',
        subtitle: 'Top {{count}} drivers of {{response}} (Sₜ)',
        tooltipSt: 'Sₜ (total-order)',
        chartAriaLabel:
          'Sensitivity tornado: top {{count}} drivers of {{response}} by total-order Sobol index. Horizontal bars extend left of zero for negative values.',
      },
      massBalance: {
        title: 'Mass-balance waterfall',
        desc: 'Flow in, flow out, and what is left over — on one baseline. A residual you cannot place in a table, like 5.5e-7 against a 0.128 inlet, reads here as a bar you can see is essentially zero.',
        emptyNoPoints: 'No completed design points yet.',
        emptyNoFlow:
          'This design point has no inlet or outlet flow rate to balance. Runs that do are unmarked in the list below.',
        tooltipFlowLabel: 'Flow rate',
        tooltipResidualLabel: 'Residual',
        pickerDp: 'Design point:',
        noFlowTag: 'no flow rate',
        spokenUnits: {
          'm³/s': 'cubic metres per second',
          'kg/s': 'kilograms per second',
        },
        srInlet: 'Inlet flow rate {{value}} {{unit}}.',
        srOutlet: 'Outlet flow rate {{value}} {{unit}}.',
        srResidual: 'Residual {{value}} {{unit}}, {{pct}}% of the flow scale.',
        srRow: '{{name}}: {{value}} {{unit}}.',
        inlet: 'Inlet',
        outlet: 'Outlet',
        chartAriaLabel:
          'Mass-balance waterfall: inlet flow, outlet flow and the residual between them. Residual {{pct}}% of the flow scale.',
      },
    },
  },
  boundaryConditionReview: {
    eyebrow: 'Boundary conditions review',
    title: 'Confirm per-patch physics before simulation',
    descriptionHave_one: '{{count}} design point has a mesh',
    descriptionHave_other: '{{count}} design points have a mesh',
    descriptionWithout: '{{count}} without',
    descriptionRest:
      '. Assign boundary-condition physics (velocity inlet, pressure outlet, wall, freestream) to each patch — the list applies to every mesh in the study.',
    resumeStudy: 'Resume study',
    resumeFailed: 'Resume failed.',
    perPatchTitle: 'Per-patch boundary conditions',
    loadingPatches: 'Loading patches…',
    withoutMesh_one: '{{count}} design point without a mesh',
    withoutMesh_other: '{{count}} design points without a mesh',
  },
  decideAnalysis: {
    iterationReview: 'Iteration {{iteration}} review',
    iterationReviewFallback: 'Iteration — review',
    headerSubtitle: 'Convergence, frontier, and proposed next points',
    completed: '{{count}} completed',
    onFrontier: '{{count}} on frontier',
    hypervolumeTitle: 'Hypervolume',
    hypervolumeEmptySubtitle: 'No completed iterations yet',
    hypervolumeSinglePointSubtitle:
      'Trajectory plots after the next iteration completes',
    hypervolumeSinglePoint: 'Iteration {{iteration}} • single data point',
    hypervolumeSubtitle:
      'Higher is better — flattening signals diminishing returns',
    hypervolumeLabel: 'Hypervolume',
    axisIteration: 'iteration',
    changeFromPrevious: 'Change from previous iteration',
    paretoTitle: 'Pareto frontier',
    paretoEmptySubtitle: 'Frontier appears after the first iteration completes',
    paretoLabel: 'Pareto frontier',
    paretoSubtitle_one:
      '{{count}} non-dominated point • dot size = HV contribution',
    paretoSubtitle_other:
      '{{count}} non-dominated points • dot size = HV contribution',
    hvContribution: 'HV contribution: {{value}}',
    hvContributionOfBest: 'HV contribution: {{value}} ({{pct}}% of best)',
    bestSoFarTitle: 'Best so far',
    bestSoFarEmptySubtitle: 'No completed runs yet',
    designPoint: 'Design point',
    frontierTableSubtitle:
      '{{count}} non-dominated points across {{objectives}} objectives — sorted by HV contribution',
    columnDp: 'DP',
    columnHv: 'HV',
    proposedForIteration: 'Proposed for iteration {{iteration}}',
    candidatesSummary_one:
      '{{count}} candidate • GP-mean predictions in natural units',
    candidatesSummary_other:
      '{{count}} candidates • GP-mean predictions in natural units',
    acquisition: 'Acquisition',
    acquisitionTooltip:
      'Joint qLogNEHVI value — higher means the optimizer expects more HV gain from this batch',
    noPredictions: 'No predictions recorded for this proposal.',
    columnDesignPoint: 'Design point',
  },
  decideReview: {
    optimizerPaused: 'Optimizer paused',
    reviewIteration: 'Review iteration {{iteration}} before continuing',
    reviewIterationFallback: 'Review this iteration before continuing',
    proposedIntro: 'The Bayesian optimizer proposed',
    proposedPoints_one: '{{count}} new design point',
    proposedPoints_other: '{{count}} new design points',
    proposedOutro:
      'for the next batch. Continue to dispatch them, or stop the study with the results so far.',
    cancelStudy: 'Cancel study',
    stopStudy: 'Stop study',
    continueIteration: 'Continue iteration',
    decisionFailed: 'Decision failed.',
  },
  paretoScatter: {
    downloadPng: 'Download chart as PNG',
    downloadHtml: 'Download chart as standalone interactive HTML',
    paretoFrontier: 'Pareto frontier',
    otherCompleted: 'Other completed',
    frontierLegend: 'Pareto frontier (size = HV contribution)',
    onFrontier: 'On frontier',
    dominated: 'Dominated',
    otherResponses: 'Other responses',
    designParameters: 'Design parameters',
    hvContribution: 'HV contribution: {{value}}',
    htmlHint: 'Hover over any point to see its design parameters.',
  },
  sensitivity: {
    title: 'Sensitivity',
    subtitle:
      'Sobol global sensitivity on the fitted surrogate — variance share per input, with bootstrap CIs',
    trainingRows: 'Surrogate training rows',
    dropped_one: '{{count}} design point dropped for incomplete responses',
    dropped_other: '{{count}} design points dropped for incomplete responses',
    saltelliEvals: 'Saltelli evaluations against the surrogate',
    bootstrapResamples: 'Bootstrap resamples per index',
    saltelliSeed: 'Saltelli seed',
    computedAt: 'Computed at',
    noIndices: 'No indices for this response',
    s1FirstOrder: 'S₁ (first-order)',
    stTotalOrder: 'Sₜ (total-order)',
    interactionsDominateTooltip:
      'Top driver {{input}}: {{pct}}% of its effect is through interactions (Sₜ − S₁)',
    interactionsDominate: 'interactions dominate',
    columnInput: 'Input',
    deltaTooltip:
      'Sₜ − S₁ — share of variance from interactions involving this input',
    varianceShare: 'variance share',
    interactionsDelta: 'interactions Δ {{value}}',
  },
  surrogateValidation: {
    title: 'Surrogate validation',
    subtitle:
      'Leave-one-out diagnostics — predicted vs. actual on the fitted GP',
    iteration: 'Iteration {{iteration}}',
    completed: '{{count}} completed',
    logSpaceTooltip:
      'Surrogate fit in log-space; values shown are untransformed to natural units',
    logSpaceFit: 'log-space fit',
    parityTitle: 'Parity',
    paritySubtitle:
      'Predicted vs. actual — tight band on y = x means trustworthy GP',
    learningCurveTitle: 'Learning curve',
    learningCurveSubtitle:
      'RMSE across iterations — flattens as surrogate converges',
    r2Tooltip: 'Leave-one-out R² of the GP surrogate',
    coverageLabel: '95% cov',
    coverageTooltip: 'Fraction of LOO truths inside ±2σ — should sit near 0.95',
    axisActual: 'actual',
    axisPredicted: 'predicted',
    axisIteration: 'iteration',
    tooltipActual: 'actual: {{value}}',
    tooltipPredicted: 'predicted: {{value}} ± {{err}}',
    tooltipResidual: 'residual: {{value}}',
    singlePoint:
      'Iteration {{iteration}} • single data point — trajectory appears after the next iteration completes',
  },
  simError: {
    hideDetails: 'Hide details ({{count}} lines)',
    showDetails: 'Show details ({{count}} lines)',
    configErrorLine: 'config error · {{kind}}',
    foamFatalTitle: 'OpenFOAM fatal error',
    solverDivergedTitle: 'Solver diverged',
    divergedIteration: 'iteration {{step}}',
    divergedUnknownIteration: 'an unknown iteration',
    divergedResidual: 'a residual',
    divergedIntro:
      'Residuals exceeded numerical bounds (NaN/Inf) at {{step}}. The',
    divergedFieldNonFinite: 'field went non-finite first.',
    commonCauses: 'Common causes (most → least likely)',
    causeFirstLayerSst:
      'First-layer cells too thin for k-ω SST — needs y+ < 5 near walls; regenerate the mesh with a tighter boundary layer.',
    causeFirstLayerRas:
      'First-layer cells too thin for the chosen flow type. Turbulence-modeled runs are especially sensitive to wall resolution.',
    causeInletVelocity:
      'Inlet velocity too high relative to mesh resolution (CFL-like instability in the steady solver).',
    causeBadMesh:
      'Bad mesh near walls — negative-volume cells. Check the mesh quality report on the mesh page.',
    causeRelaxation:
      'Under-relaxation too aggressive. Lower the pressure and velocity relaxation factors under Solver → Advanced (typical: pressure ≤ 0.2, velocity ≤ 0.5).',
    pressureSolveTitle: 'Solver crashed in the pressure solve',
    pressureSolveIntro:
      'Solver hit a floating-point error at {{step}} — usually the pressure solver failing on a poor-quality cell.',
    thingsToTry: 'Things to try',
    tryPcg: 'Switch to PCG / PBiCGStab in',
    trySolverPExposed: 'if exposed.',
    tryOneRegion:
      'Verify the mesh has only one connected fluid region (see the mesh quality report).',
    tryReduceRelaxPPre: 'Reduce',
    tryReduceRelaxPPost: 'to 0.1 for one run as a diagnostic.',
    chtFailedTitle: 'CHT solver failed',
    chtIntro:
      'Conjugate heat transfer requires a multi-region mesh — and the schema for CHT BCs differs from external_flow.',
    chtPitfalls: 'Common CHT pitfalls',
    chtElementType: 'Mesh must be generated with element_type:',
    chtElementTypePost:
      'AND have at least one face_tag for the fluid/solid interface.',
    chtBoundaryConditionsPost:
      'must include a FluidInletThermalBC for the fluid region.',
    chtSolidBcs:
      'Solid BCs use face_id (mesh tag), not patch name — different schema from external_flow.',
    diagnosisFieldLabel: 'Change input',
    evidenceLabel: 'Measured',
    evidenceContactPairs: 'contact pairs requested',
    evidenceContactElements: 'contact elements formed',
    evidenceIterations: 'iterations recorded',
    evidenceResidualTrend: 'residual',
    residualTrend: {
      falling: 'still falling',
      flat: 'flat',
      oscillating: 'oscillating',
    },
    genericExitTitle: 'Solver exited with code {{code}}',
    genericExitBody:
      'No structured failure detail was extracted from this run. Check the raw solver log for diagnostics.',
    preflightTitle: 'Study could not be submitted',
    hints: {
      foamFatal: {
        patchFieldMissing:
          'A patch exists in the mesh but no BC was set for it. Add a boundary_conditions entry for the missing patch.',
        unknownPatchType:
          "Patch type mismatch — a face_tags label may have sanitized into a reserved name. Rename the tag in MeshGen's Boundary Assignment.",
        keywordUndefined:
          'A required field is missing in the OpenFOAM case dict — likely a backend bug. Please report.',
        polyMeshMissing:
          'The mesh upload is incomplete or corrupted. Re-mesh the geometry and re-run.',
      },
      config: {
        bcPatchMismatchTitle: "Patch names don't match the mesh",
        bcPatchMismatchHint:
          "The boundary_conditions reference patches that don't exist in the mesh's polyMesh. Open the BC editor and check the names — meshgen often prefixes labels with `body_` or splits one label across `_000` / `_001` for multi-face tags.",
        meshInvalidTitle: 'Mesh file unreadable',
        meshInvalidHint:
          'The selected mesh failed to load (corrupt polyMesh, missing files, or unsupported format). Re-mesh the geometry from MeshGen and re-submit.',
        bcMissingInletTitle: 'No velocity source defined',
        bcMissingInletHint:
          'External-flow studies need at least one patch with a velocity-bearing BC (Velocity inlet or Freestream). Open the BC editor and set one.',
        bcMissingOutletTitle: 'No outlet defined',
        bcMissingOutletHint:
          'Set at least one patch to Pressure outlet (or Freestream for external aero). Without a pressure-fixing BC the pressure equation is unbounded and the solver diverges on the first iteration.',
        bcInterfaceReservedTitle: 'Fluid–solid interface patch reassigned',
        bcInterfaceReservedHint:
          "One of the BCs targets an internal fluid-solid interface patch (`<a>_to_<b>`). These are auto-managed by the energy coupling and can't be re-roled. Remove that row and re-pick the wall / inlet / outlet on a real boundary patch.",
        unknownTitle: 'Configuration error',
      },
      preflight: {
        noInletVelocityTitle: 'No inlet velocity set',
        noInletVelocityFix:
          'Inlet velocity cannot be 0. In Step 3 → Boundary Conditions, set one patch to "Velocity inlet" or "Freestream" with a non-zero velocity.',
        bcMissingTitle: 'Boundary conditions missing',
        bcMissingFix:
          'In Step 3 → Boundary Conditions, assign physics to each mesh patch (inlet, outlet, wall, etc.).',
        turbulentLengthScaleTitle: 'Turbulent length scale not set',
        turbulentLengthScaleFix:
          'In Solver settings → Turbulence, set Length Scale to ~7–10% of your body characteristic length.',
        manualDpStaleInputTitle:
          'Manual design point points at an input that is no longer selected',
        manualDpStaleInputFix:
          'Remove the flagged manual design point (red outline in the preview) or re-add the mesh / geometry it targets, then Run again.',
      },
    },
  },
} as const;
